module.exports = __webpack_public_path__ + "img/book.ad37f4a2.svg";